import { EventObject } from '@xstate/store-react';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { saveSession } from '../../../services/session/save';
import { log } from '@domgen/shared/utils/log';

/**
 * Records that the call us modal has been shown, so it only appears once per session.
 *
 * Persists the updated context so the modal stays dismissed after a page reload.
 *
 * @param context Current store context.
 * @param _event Unused event payload.
 * @returns Updated context with the call us modal marked as shown.
 */
export const callUsModalShown = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
): StoreContext => {
  log.debug({ message: StoreEvent.CALL_US_MODAL_SHOWN });

  const updatedContext = {
    ...context,
    app: {
      ...context.app,
      callUsModalShown: true,
    },
  };

  saveSession(updatedContext);
  return updatedContext;
};
